export default __webpack_public_path__ + "static/media/IMG_9960.c034e033.jpg";